import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/site/Form";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "./Login";

export default function SetPassword() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState(null);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 9) return setErr("Use at least 9 characters.");
    if (pw !== pw2) return setErr("The passwords don't match.");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password: pw });
      setDone(true);
    } catch (ex) {
      setErr(errMsg(ex));
    }
  };
  return (
    <AuthShell title="Choose a password">
      {done ? (
        <p className="mt-4 text-slate-700" data-testid="set-password-done">Your password has been set. <Link className="link" to="/dealer/login">Sign in</Link></p>
      ) : (
        <form onSubmit={submit} className="mt-5 space-y-4" data-testid="set-password-form">
          <Field label="New password" htmlFor="pw" hint="At least 9 characters."><input id="pw" type="password" autoComplete="new-password" className="field-input" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="set-password-input" /></Field>
          <Field label="Confirm password" htmlFor="pw2"><input id="pw2" type="password" autoComplete="new-password" className="field-input" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="set-password-confirm-input" /></Field>
          {err && <p className="text-sm text-destructive" role="alert" data-testid="set-password-error">{err}</p>}
          <Button type="submit" className="w-full" data-testid="set-password-submit-button">Save password</Button>
        </form>
      )}
    </AuthShell>
  );
}
